// ═══════════════════════════════════════════════════════════════════════════════
// Employer getting-started — "?" next to greeting (same HelpPopover pattern)
// ═══════════════════════════════════════════════════════════════════════════════

import type { EmployerGettingStartedProgress } from '@fdh/shared';
import { useLanguage } from '../../contexts/LanguageContext';
import { HelpPopover } from '../ui/HelpPopover';
import {
  EmployerGettingStartedCard,
  type GettingStartedStepId,
} from './EmployerGettingStartedCard';

type EmployerGettingStartedHelpPopoverProps = {
  progress: EmployerGettingStartedProgress;
  onStepClick: (stepId: GettingStartedStepId) => void;
};

export const EmployerGettingStartedHelpPopover = ({
  progress,
  onStepClick,
}: EmployerGettingStartedHelpPopoverProps) => {
  const { t } = useLanguage();

  return (
    <HelpPopover
      triggerAriaLabel={t('employerDashboard.gettingStarted.helpTriggerAria')}
      panelAriaLabel={t('employerDashboard.gettingStarted.regionAria')}
      panelWidthClassName="w-[22rem]"
      estimatedPanelHeightPx={420}
      className="ml-0.5"
    >
      <EmployerGettingStartedCard
        progress={progress}
        variant="compact"
        onStepClick={onStepClick}
      />
    </HelpPopover>
  );
};
